import React from 'react';
import Loader from '../../../../components/Loader';
import { useUserDetail } from '../context/UserDetailContext';
import UserStatusBadge from '../../components/UserStatusBadge';
function dateLabel(value, withTime = false) {
  if (!value || Number.isNaN(new Date(value).getTime())) return '—';
  const options = { day: '2-digit', month: 'short', year: 'numeric' };
  return withTime ? new Date(value).toLocaleString('en-GB', { ...options, hour: '2-digit', minute: '2-digit' }) : new Date(value).toLocaleDateString('en-GB', options);
}
function DetailsCard({ title, fields }) {
  return <section className="min-w-0 rounded-xl border border-slate-100 bg-white p-6 shadow-sm"><h2 className="mb-5 font-bold text-slate-900">{title}</h2>
    <dl className="grid grid-cols-1 gap-x-6 gap-y-5 sm:grid-cols-2">{fields.map(([label, value]) => <div key={label} className="min-w-0">
      <dt className="text-xs font-semibold text-slate-500">{label}</dt><dd className="mt-1.5 break-words text-sm text-slate-900">{value || '—'}</dd>
    </div>)}</dl></section>;
}
export default function UserProfileDetails() {
  const { user, loading, error, reload } = useUserDetail();
  if (loading) return <Loader message="Loading user profile..." className="py-16" />;
  if (error || !user) return <div role="alert" className="rounded-xl border border-red-100 bg-white p-6 text-sm text-red-600">{error || 'User profile not found.'}<button type="button" onClick={reload} className="ml-3 underline">Retry</button></div>;
  return <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
    <DetailsCard title="User Information" fields={[
      ['Full Name', user.fullName], ['Employee ID', user.employeeId], ['Email Address', user.email],
      ['Mobile Number', user.mobileNumber], ['Job Title', user.jobTitle], ['Department', user.departmentName],
      ['Branch Access', user.branchName], ['Date of Joining', dateLabel(user.dateOfJoining)],
    ]} />
    <DetailsCard title="Account & Role" fields={[
      ['Role', user.role?.name], ['Status', <UserStatusBadge status={user.status} />],
      ['Created', dateLabel(user.createdAt, true)], ['Last Updated', dateLabel(user.updatedAt, true)],
      ['Role Description', user.role?.description],
    ]} />
  </div>;
}
